import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  orderBy,
  limit,
  getDocs,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

export default function TopViewedNews() {
  const [news, setNews] = useState([]);

  useEffect(() => {
    const loadNews = async () => {
      const q = query(
        collection(db, "news"),
        orderBy("views", "desc"),
        limit(20)
      );

      const snap = await getDocs(q);

      setNews(
        snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );
    };

    loadNews();
  }, []);

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: 6,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          background: "#8b0000",
          color: "#fff",
          padding: "14px 18px",
          fontSize: 20,
          fontWeight: "bold",
        }}
      >
        🏆 সর্বাধিক পঠিত ২০টি সংবাদ
      </div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr
            style={{
              background: "#f5f5f5",
              borderBottom: "2px solid #ddd",
            }}
          >
            <th
              style={{
                width: 70,
                padding: 12,
                textAlign: "center",
              }}
            >
              #
            </th>

            <th
              style={{
                padding: 12,
                textAlign: "left",
              }}
            >
              শিরোনাম
            </th>

            <th
              style={{
                width: 120,
                padding: 12,
                textAlign: "center",
              }}
            >
              Views
            </th>
          </tr>
        </thead>

        <tbody>
          {news.map((item, index) => (
            <tr
              key={item.id}
              style={{
                borderBottom: "1px solid #eee",
              }}
            >
              <td
                style={{
                  padding: 12,
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "#8b0000",
                }}
              >
                {index + 1}
              </td>

              <td
                style={{
                  padding: 12,
                  lineHeight: 1.7,
                  fontSize: 16,
                }}
              >
               <a
  href={`/${item.categorySlug}/${item.subcategorySlug}/${item.id}`}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    color: "#222",
    textDecoration: "none",
    fontWeight: 500,
    transition: "0.2s",
  }}
  onMouseEnter={(e) => {
    e.target.style.color = "#8b0000";
    e.target.style.textDecoration = "underline";
  }}
  onMouseLeave={(e) => {
    e.target.style.color = "#222";
    e.target.style.textDecoration = "none";
  }}
>
  {item.title}
</a>
              </td>

              <td
                style={{
                  padding: 12,
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "#8b0000",
                  fontSize: 16,
                }}
              >
                {(item.views || 0).toLocaleString()}
              </td>
            </tr>
          ))}

          {news.length === 0 && (
            <tr>
              <td
                colSpan={3}
                style={{
                  padding: 40,
                  textAlign: "center",
                  color: "#777",
                }}
              >
                কোনো তথ্য পাওয়া যায়নি।
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}